export const AGE_LIMIT =
  'Setur Seyahat Asistanı’na erişim sağlamak için 18 (on sekiz) yaşını doldurmam gerektiğini bildiğimi kabul ve beyan ederim.';
